import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["operationSkeleton", "textSkeleton"]

  initialize() {
    this.element.querySelectorAll("turbo-frame[loading='lazy']:not([complete]):not([busy])").forEach((frame) => {
      frame.removeAttribute("disabled")
    })
  }

  saveNavigationParams(event) {
    this.activeSection = event.detail.section
    this.attributeId = event.detail.attributeId
    this.highlight = event.detail.highlight
  }

  beforeRequest(event) {
    const frame = event.target
    const skeletonName = frame.getAttribute("data-skeleton-target-name") || "textSkeletonTarget"
    const skeleton = this[skeletonName].content.cloneNode(true)

    // Ideally we could target only :-moz-only-whitespace divs but the
    // existing :empty CSS selector doesn't select nodes with a child
    // with whitespace only text...
    if (!frame.hasChildNodes() || (frame.childNodes.length === 1 && frame.childNodes[0].nodeType === Node.TEXT_NODE)) {
      frame.appendChild(skeleton)
    }
  }

  frameMissing(event) {
    event.preventDefault()
    event.target.innerHTML = "An error has occured while retrieving this content."
    event.target.classList.add("missing-frame")
  }

  beforeRender(event) {
    if (!this.highlight && this.#isAboveViewport(event.target)) {
      event.detail.render = (currentElement, newElement) => {
        window.requestAnimationFrame(() => {
          this.#saveScrollPosition()
          currentElement.innerHTML = newElement.innerHTML
          this.#maintainScrollTop()
        })
      }
    }
  }

  afterRender(event) {
    if (event.target === this.activeSection) {
      const attributeId = this.attributeId
      const attribute = attributeId && document.getElementById(attributeId)
      const activeItem = attribute || this.activeSection
      // Update back link for doc-back-link enabled items
      this.dispatch("doc-back-link:update", { prefix: false, target: activeItem })
      if (this.highlight) {
        this.dispatch("highlight", { target: document, detail: { element: activeItem }, prefix: false })
      }
      this.dispatch("goTo", { target: document, detail: { element: activeItem }, prefix: false })
    }
  }

  afterLoad() {
    this.#resetNavigationParams()
  }

  #saveScrollPosition() {
    this.scrollPosition = this.element.scrollHeight + this.element.getBoundingClientRect().y
  }

  #maintainScrollTop() {
    const newYPosition = (this.element.scrollHeight - this.scrollPosition)
      + (document.getElementById("embed-top-body")?.getBoundingClientRect()?.height || 0)
      + 65 // Height of the top Portal Header or Mobile menu toggle
    window.scrollTo(0, newYPosition)
  }

  #resetNavigationParams() {
    this.activeSection = null
    this.attributeId = null
    this.highlight = null
  }

  #isAboveViewport(element) {
    return element.getBoundingClientRect().top < 0
  }
}
